module.exports = __webpack_public_path__ + "static/media/mpc.23ac3899.svg";